// Google Analytics, Google Ads and Google Tag Manager Utility

const GA_TRACKING_ID = import.meta.env.VITE_GA_TRACKING_ID;
const ADS_CONVERSION_ID = import.meta.env.VITE_ADS_CONVERSION_ID;
const ADS_CONVERSION_LABEL = import.meta.env.VITE_ADS_CONVERSION_LABEL;
const ADS_FORM_CONVERSION_LABEL = import.meta.env.VITE_ADS_FORM_CONVERSION_LABEL;
const GTM_ID = import.meta.env.VITE_GTM_ID;

const isDev = import.meta.env.DEV;

export function initAnalytics() {
  if (typeof window === 'undefined') return;

  // 1. Google Tag Manager (GTM) Initialization
  if (GTM_ID) {
    if (isDev) {
      console.log(`[Analytics] Inicializando Google Tag Manager (${GTM_ID}) em modo desenvolvimento.`);
    }
    
    // GTM script injection
    if (!document.getElementById('gtm-script')) {
      const gtmScript = document.createElement('script');
      gtmScript.id = 'gtm-script';
      gtmScript.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
      `;
      document.head.appendChild(gtmScript);
      
      // GTM noscript injection
      const gtmNoscript = document.createElement('noscript');
      const gtmIframe = document.createElement('iframe');
      gtmIframe.src = `https://www.googletagmanager.com/ns.html?id=${GTM_ID}`;
      gtmIframe.height = '0';
      gtmIframe.width = '0';
      gtmIframe.style.display = 'none';
      gtmIframe.style.visibility = 'hidden';
      gtmNoscript.appendChild(gtmIframe);
      document.body.insertBefore(gtmNoscript, document.body.firstChild);
    }
  }

  // 2. Google Tag (gtag.js) Initialization
  if (GA_TRACKING_ID || ADS_CONVERSION_ID) {
    const mainId = GA_TRACKING_ID || ADS_CONVERSION_ID;
    
    if (isDev) {
      console.log(`[Analytics] Inicializando gtag.js (GA: ${GA_TRACKING_ID || 'Não configurado'}, Ads: ${ADS_CONVERSION_ID || 'Não configurado'}) em modo desenvolvimento.`);
    }

    if (!document.getElementById('gtag-script')) {
      // Load script
      const script = document.createElement('script');
      script.id = 'gtag-script';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${mainId}`;
      document.head.appendChild(script);

      // Initialize dataLayer
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer?.push(arguments);
      };
      
      window.gtag('js', new Date());

      // Config GA4
      if (GA_TRACKING_ID) {
        window.gtag('config', GA_TRACKING_ID, {
          send_page_view: true
        });
      }

      // Config Google Ads
      if (ADS_CONVERSION_ID) {
        window.gtag('config', ADS_CONVERSION_ID);
      }
    }
  }
}

/**
 * Rastreia cliques no botão de WhatsApp. Dispara evento no GA4, Google Ads e GTM dataLayer.
 * @param locationName Identificador de qual botão foi clicado (ex: "header", "footer", "hero", etc.)
 */
export function trackWhatsAppClick(locationName: string) {
  if (isDev) {
    console.log(`[Analytics Event] WhatsApp clicado! Origem: ${locationName}`);
  }

  // Enviar para o GTM
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'whatsapp_click',
      whatsapp_location: locationName
    });
  }

  // Enviar para o GA4 via gtag
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    if (GA_TRACKING_ID) {
      window.gtag('event', 'whatsapp_click', {
        event_category: 'Engagement',
        event_label: locationName
      });
    }

    // Enviar Conversão do Google Ads
    if (ADS_CONVERSION_ID && ADS_CONVERSION_LABEL) {
      if (isDev) {
        console.log(`[Analytics Event] Disparando conversão Google Ads WhatsApp (${ADS_CONVERSION_ID}/${ADS_CONVERSION_LABEL})`);
      }
      window.gtag('event', 'conversion', {
        send_to: `${ADS_CONVERSION_ID}/${ADS_CONVERSION_LABEL}`,
        value: 1.0,
        currency: 'BRL'
      });
    }
  }
}

/**
 * Rastreia o envio bem-sucedido de um formulário de contato.
 */
export function trackContactFormSubmit() {
  if (isDev) {
    console.log('[Analytics Event] Formulário de contato enviado com sucesso!');
  }

  // Enviar para o GTM
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'contact_form_submit'
    });
  }

  // Enviar para o GA4 via gtag
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    if (GA_TRACKING_ID) {
      window.gtag('event', 'generate_lead', {
        event_category: 'Lead',
        event_label: 'Contact Form'
      });
    }

    // Enviar Conversão do Google Ads para o formulário
    if (ADS_CONVERSION_ID && ADS_FORM_CONVERSION_LABEL) {
      if (isDev) {
        console.log(`[Analytics Event] Disparando conversão Google Ads Formulário (${ADS_CONVERSION_ID}/${ADS_FORM_CONVERSION_LABEL})`);
      }
      window.gtag('event', 'conversion', {
        send_to: `${ADS_CONVERSION_ID}/${ADS_FORM_CONVERSION_LABEL}`,
        value: 1.0,
        currency: 'BRL'
      });
    }
  }
}
